import React, { FC } from "react";
import CustomerEmailModal from "../components/orderSummary/modals/CustomerEmail/CustomerEmailModal";
import EmailWarningModal from "../components/orderSummary/modals/EmailWarning/EmailWarningModal";
import { IconButton, Tooltip, Button } from "@mui/material";
import { Email as EmailIcon } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { allDealerActAccess } from "../pages/OrderSummary/OrderSummary";

const StyledSpan = styled("span")({
  fontWeight: "bold",
  paddingLeft: 5,
  paddingRight: 5,
});

const StyledButton = styled(Button)({
  color: "black",
  marginBottom: 5,
});

const StyledDivColStart2 = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  position: "relative",
});

const StyledDivMail = styled("div")(({ theme }) => ({
  position: "absolute",
  top: -35,
  right: -10,
  zIndex: 1000,
  [theme.breakpoints.down("lg")]: {
    top: 0,
    right: -50,
  },
}));

interface CustomerPDFProps {
  signInRole: string;
  dealerEmail: string;
  customerEmail: string;
  openCustomerEmailModal: boolean;
  customerUrl: string;
  handleClose: () => void;
  quoteNumber: number;
  openWarning: boolean;
  handleCloseWarning: () => void;
  handleOpen: () => void;
  handleOpenWarning: () => void;
  margin: number;
  handlePDF: () => void;
  pdfObj: { [key: string]: any };
}

const CustomerPDF: FC<CustomerPDFProps> = ({
  signInRole,
  dealerEmail,
  customerEmail,
  quoteNumber,
  openCustomerEmailModal,
  handleClose,
  customerUrl,
  openWarning,
  handleCloseWarning,
  handleOpen,
  margin,
  handleOpenWarning,
  handlePDF,
  pdfObj,
}) => {
  const fileName = `AGMillworks(PC-${quoteNumber})Customer.pdf`;

  if (allDealerActAccess(signInRole) || signInRole === "Admin") {
    return (
      <>
        <CustomerEmailModal
          customerEmail={customerEmail || ""}
          dealerEmail={dealerEmail || ""}
          fileName={fileName}
          open={openCustomerEmailModal}
          handleClose={handleClose}
          handlePDF={handlePDF}
          pdfObj={pdfObj}
          pdfUrl={customerUrl}
        />

        <EmailWarningModal
          open={openWarning}
          handleClose={handleCloseWarning}
          handleOpenEmailModal={handleOpen}
        />

        <StyledDivColStart2>
          <StyledDivMail>
            <Tooltip title="Email to Customer" placement="top">
              <IconButton
                onClick={!margin ? handleOpenWarning : handleOpen}
                style={{ alignSelf: "flex-end" }}
              >
                <EmailIcon style={{ fontSize: 18 }} color="primary" />
              </IconButton>
            </Tooltip>
          </StyledDivMail>

          <a
            style={{ textDecoration: "none" }}
            href={customerUrl}
            download={fileName}
          >
            <StyledButton
              variant="contained"
              style={{ backgroundColor: "#21c7f5" }}
            >
              <StyledSpan> Customer </StyledSpan> Details
            </StyledButton>
          </a>
        </StyledDivColStart2>
      </>
    );
  }

  return null;
};

export default CustomerPDF;
